'use client';

import React, { useEffect, useRef } from 'react';

const values = [
  {
    number: '01',
    title: 'Accurate Diagnostics First',
    desc: 'We never guess. Every repair starts with proper diagnostic assessment using modern OBD-II tools and professional equipment to identify the exact problem before any work begins.',
    color: '#c60000',
  },
  {
    number: '02',
    title: 'Complete Transparency',
    desc: 'We explain every repair in clear language, show you the diagnostic results, and provide a full cost estimate before starting. No surprise bills — ever.',
    color: '#c60000',
  },
  {
    number: '03',
    title: 'Quality Parts & Materials',
    desc: 'We use genuine and quality-certified spare parts, oils, and lubricants. Your vehicle deserves the right components — not cheap substitutes that fail prematurely.',
    color: '#4db6ff',
  },
  {
    number: '04',
    title: 'Continuous Technician Training',
    desc: 'Our mechanics receive ongoing training in the latest automotive technologies — including electric vehicle systems — to stay current with the vehicles Ethiopian drivers use.',
    color: '#4db6ff',
  },
  {
    number: '05',
    title: 'Safety is Non-Negotiable',
    desc: 'Every safety-critical system — brakes, steering, suspension — is inspected and repaired to the highest standards. We will not return a vehicle to the road if it is not safe.',
    color: '#c60000',
  },
  {
    number: '06',
    title: 'Customer Respect & Comfort',
    desc: 'We treat every customer with respect, communicate clearly, and provide a comfortable waiting environment with free WiFi and café service while your vehicle is being serviced.',
    color: '#4db6ff',
  },
];

export default function ValuesSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal').forEach((el, i) => {
              setTimeout(() => el.classList.add('active'), i * 90);
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/about/components/ValuesSection.tsx:65:4" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="65" data-component-end-line="139" data-component-file="ValuesSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20md%3Apy-28%22%7D"
      ref={sectionRef}
      className="py-20 md:py-28"
      style={{ background: '#000000', borderTop: '1px solid rgba(255,255,255,0.06)' }}
      aria-labelledby="values-heading"
    >
      <div data-component-id="src/app/about/components/ValuesSection.tsx:71:6" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="71" data-component-end-line="138" data-component-file="ValuesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-container%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-container mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/app/about/components/ValuesSection.tsx:72:8" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="72" data-component-end-line="89" data-component-file="ValuesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22reveal%20mb-14%22%7D" className="reveal mb-14">
          <p data-component-id="src/app/about/components/ValuesSection.tsx:73:10" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="73" data-component-end-line="73" data-component-file="ValuesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22section-label%22%2C%22textContent%22%3A%22Our%20Values%22%7D" className="section-label">Our Values</p>
          <h2 data-component-id="src/app/about/components/ValuesSection.tsx:74:10" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="74" data-component-end-line="88" data-component-file="ValuesSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22id%22%3A%22values-heading%22%2C%22className%22%3A%22font-heading%22%2C%22textContent%22%3A%22The%20Principles%20Behind%20Every%22%7D"
            id="values-heading"
            className="font-heading"
            style={{
              fontSize: 'clamp(26px, 3.5vw, 44px)',
              color: '#f7f8fd',
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 800,
              letterSpacing: '-0.03em',
              maxWidth: '560px',
            }}
          >
            The Principles Behind Every{' '}
            <span data-component-id="src/app/about/components/ValuesSection.tsx:87:12" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="87" data-component-end-line="87" data-component-file="ValuesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Repair%20We%20Do%22%7D" style={{ color: '#c60000' }}>Repair We Do</span>
          </h2>
        </div>

        <div data-component-id="src/app/about/components/ValuesSection.tsx:91:8" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="91" data-component-end-line="137" data-component-file="ValuesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-px%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: 'rgba(255,255,255,0.06)' }}>
          {values.map((value, i) => (
            <div data-component-id="src/app/about/components/ValuesSection.tsx:93:12" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="93" data-component-end-line="135" data-component-file="ValuesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={value.number}
              className={`reveal delay-${(i + 1) * 100} p-8 group`}
              style={{
                background: '#0d0d0d',
                transition: 'background 0.3s ease',
              }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLDivElement).style.background = '#141414'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLDivElement).style.background = '#0d0d0d'; }}
            >
              <div data-component-id="src/app/about/components/ValuesSection.tsx:103:14" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="103" data-component-end-line="115" data-component-file="ValuesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22font-heading%20mb-4%22%7D"
                className="font-heading mb-4"
                style={{
                  fontSize: '52px',
                  color: `${value.color}15`,
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 800,
                  lineHeight: 1,
                  letterSpacing: '-0.04em',
                }}
              >
                {value.number}
              </div>
              <div data-component-id="src/app/about/components/ValuesSection.tsx:116:14" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="116" data-component-end-line="119" data-component-file="ValuesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-10%20h-0.5%20mb-5%22%7D"
                className="w-10 h-0.5 mb-5"
                style={{ background: value.color }}
              />
              <h3 data-component-id="src/app/about/components/ValuesSection.tsx:120:14" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="120" data-component-end-line="131" data-component-file="ValuesSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-heading%20mb-3%22%7D"
                className="font-heading mb-3"
                style={{
                  fontSize: '18px',
                  color: '#f7f8fd',
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 700,
                  lineHeight: 1.3,
                }}
              >
                {value.title}
              </h3>
              <p data-component-id="src/app/about/components/ValuesSection.tsx:132:14" data-component-path="src/app/about/components/ValuesSection.tsx" data-component-line="132" data-component-end-line="134" data-component-file="ValuesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D" style={{ color: '#888888', fontSize: '14px', lineHeight: 1.7, fontFamily: 'DM Sans, sans-serif' }}>
                {value.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}